<template>
  <component :is="resolvedComponent" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import ConfettiComponent from "components/global/celebration/ConfettiComponent.vue";
import ClipboardComponent from "components/global/celebration/ClipboardComponent.vue";

interface Props {
  celebrationType: "confetti" | "clipboard";
}

const props = defineProps<Props>();

const resolvedComponent = computed(() => {
  return props.celebrationType === "confetti"
    ? ConfettiComponent
    : ClipboardComponent;
});
</script>
